import { useState }          from 'react'
import { SelectOption }      from '../../../components/Select/Select'
import { Button, TextField } from '../../index'

export default function SettingsVariantVariationForm( props: any ): JSX.Element {
  const { handleFormSubmit, variation, shopVariants } = props
  const [ name, setName ]                             = useState( variation?.name ?? '' )
  const [ parentId, setParentId ]                     = useState( variation?.variant_id ?? '' )
  const [ nameError, setNameError ]                   = useState( false )
  const [ parentIdError, setParentIdError ]           = useState( false )

  const handleSubmit: any = (): any => {
    setNameError( false )
    setParentIdError( false )

    if ( !name.length ) {
      setNameError( true )
      return
    }

    if ( !parentId.length ) {
      setParentIdError( true )
      return
    }

    if ( variation?.name === name && variation.variant_id === parentId ) return

    handleFormSubmit( name, parentId, variation?.id ?? '' )
  }

  return (
    <div className="flex flex-col w-full bg-white rounded-3xl p-4 xl:p-5 space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <SelectOption
            wrapperClasses="w-full"
            setSelected={ setParentId }
            selected={ parentId }
            placeholder="Variants"
            fieldClasses={ `py-4 px-5 border ${ parentIdError ? 'border-red-600' : 'border-grey-light' } rounded-2xl w-full text-blue-input placeholder-grey-input` }
            options={ shopVariants.map( ( variant: any ): any => {
              return { key: variant.id, value: variant.name }
            } ) }
          />
          <TextField
            label=""
            value={ name }
            name="name"
            type="text"
            onChange={ setName }
            placeholder={ variation?.id ? '' : 'Type new variation name ...' }
            wrapperClasses="w-full"
            containerClasses="w-full"
            fieldClasses={ `py-4 px-5 border ${ nameError ? 'border-red-600' : 'border-grey-light' } rounded-2xl w-full text-blue-input font-medium placeholder-grey-input` }
            isRequired
          />
        </div>
        <div className="flex flex-wrap items-center">
          <Button label={ variation ? 'Update' : 'Create' } yellow onClick={ handleSubmit } />
        </div>
      </div>
    </div>
  )
}
